import { Grid, Typography } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import User from "./User";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import CounterType from "./CounterType";
import Loading6 from "../../assets/loading/loading6.gif";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ListCounterTypes = (props) => {
  const user = useSelector((state) => state.user);

  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  // const thisProjectCounterTypesInfo = useSelector((state) => {
  //   return state.projects.filter(
  //     (p) => p.water_meter_project_id == props.projectId
  //   );
  // });

  const thisProjectCounterTypes = useCustomState([]);

  // useEffect(() => {
  //   if (thisProjectCounterTypesInfo.length > 0) {
  //     thisProjectCounterTypes.handleChange(
  //       extractCounterTypeInfo(thisProjectCounterTypesInfo[0])
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (!props.isLoading.value) {
      thisProjectCounterTypes.handleChange(
        extractCounterTypeInfo(props.project)
      );
    }
  }, [props.isLoading.value]);

  const renderContent = () => {
    if (props.isLoading.value) {
      return (
        <Grid container>
          <div
            style={{
              width: "100%",
              height: "260px",
              marginTop: "48px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              position: "relative",
            }}
          >
            <img
              src={Loading6}
              style={{
                width: "180px",
                height: "180px",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
              alt="Loading..."
            />
          </div>
        </Grid>
      );
    } else {
      return (
        <Grid container>
          {thisProjectCounterTypes.value.map((type, idx) => {
            return (
              <CounterType
                data={type}
                key={idx}
                index={idx}
                projectId={props.projectId}
                renderDetails={user.permissions.includes("Base")}
              />
            );
          })}
        </Grid>
      );
    }
  };
  return (
    <Grid
      container
      style={{
        paddingRight: "16px",
        paddingLeft: "16px",
        marginBottom: "24px",
      }}
    >
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"انواع کنتور مورد استفاده در این پروژه"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
              }}
            >
              {renderContent()}
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ListCounterTypes;

const extractCounterTypeInfo = (project) => {
  const results = [];
  let data;
  // console.log(project);
  project.types.map((type) => {
    data = {
      id: type.water_meter_type_id,
      name: type.water_meter_type_name,
      projects: 0,
      counters: 0,
      category: type.water_meter_tag.water_meter_tag_name,
    };
    // console.log("data", data);
    results.push(data);
  });
  return results;
};
